module.exports = __webpack_public_path__ + "img/bg-magento-find-out@2x.1c35032d.jpeg";